import { useSelector } from 'react-redux';

import { ExportProgressBar } from './ExportProgressBar';
import {
  selectAsyncExcelExportProgress,
  selectShowAsyncExcelExportProgressBar,
} from '../../../store/slices/async-excel-export.slice';

export function ExcelExportProgressBar() {
  const value = useSelector(selectAsyncExcelExportProgress);
  const show = useSelector(selectShowAsyncExcelExportProgressBar);

  return (
    <ExportProgressBar
      value={value}
      show={show}
      title="Hang tight, your Excel is on its way!"
      subtitle="It will auto-download"
    />
  );
}
